import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { DEFAULT_CHAIN_ID } from '@/lib/config/chain';

export function PreferenceSync({
  routes = [
    'hot-list',
    'ai-agent',
    'my-assets',
    'transaction-configuration',
    'wallet-management',
  ],
}) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastPathname = pathname.split('/').pop();

  useEffect(() => {
    // 只在指定路由上添加查询参数
    if (!routes.includes(lastPathname ?? '- -')) return;

    // 获取所有可能的偏好键
    const allKeys = ['chainId']; // 添加所有可能的键

    let newSearchParams = new URLSearchParams(searchParams.toString());
    let shouldUpdate = false;

    allKeys.forEach((key) => {
      if (!searchParams.has(key)) {
        const value = localStorage.getItem(key);
        if (value) {
          newSearchParams.set(key, value);
          shouldUpdate = true;
        }
      }
    });

    if (!newSearchParams.has('chainId')) {
      newSearchParams.set('chainId', DEFAULT_CHAIN_ID);
      shouldUpdate = true;
    }

    if (shouldUpdate) {
      router.replace(`${pathname}?${newSearchParams.toString()}`);
    }
  }, [pathname, searchParams, router, routes, lastPathname]);

  // 这个组件不渲染任何内容
  return null;
}
